import { JSONSchemaType } from 'ajv'
import validationPatters from 'schema/patterns'

export interface IUserSecurityFormData {
  id: string
  userGroupId: string
  name: string
  email: string
  password: string
  isAdmin: boolean
  isSuperUser: boolean
  isBlocked: boolean
  blockReasonId: string
  mustChangePasswordNextLogon: boolean
  isDisabled: boolean
  avatar: string
}

const UserSecuritySchema: JSONSchemaType<IUserSecurityFormData> = {
  type: 'object',
  properties: {
    id: {
      type: 'string',
    },
    userGroupId: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    name: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    email: {
      type: 'string',
      pattern: validationPatters.email,
      minLength: 1,
      errorMessage: 'Campo obrigatório.',
    },
    password: {
      type: 'string',
    },
    isAdmin: {
      type: 'boolean',
      default: false,
    },
    isSuperUser: {
      type: 'boolean',
      default: false,
    },
    isBlocked: {
      type: 'boolean',
      default: false,
    },
    blockReasonId: {
      type: 'string',
    },
    mustChangePasswordNextLogon: {
      type: 'boolean',
      default: false,
    },
    isDisabled: {
      type: 'boolean',
      default: false,
    },
    avatar: {
      type: 'string',
    },
  },
  required: ['userGroupId', 'name', 'email'],
  additionalProperties: false,
}

export default UserSecuritySchema
